import React from 'react';
import { ChartBarIcon, ClockIcon } from '@heroicons/react/24/outline';

interface WelcomeHeaderProps {
  userName: string;
  currentStreak: number;
  totalPoints: number;
}

const WelcomeHeader = ({
  userName,
  currentStreak,
  totalPoints
}: WelcomeHeaderProps) => {
  return (
    <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-8 lg:p-10">
      <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
        {/* Welcome Text */}
        <div className="space-y-2">
          <h1 className="text-3xl lg:text-4xl font-semibold text-gray-900">
            Welcome back, {userName}
          </h1>
          <p className="text-gray-600 text-base">
            Continue your learning progress
          </p>
        </div>
        
        {/* Stats Cards */}
        <div className="flex gap-4 lg:gap-6">
          {/* Active Days Card */}
          <div className="flex items-center gap-3 bg-gray-50 border border-gray-200 rounded-lg px-5 py-4 min-w-[160px]">
            <ClockIcon className="w-7 h-7 text-gray-600" />
            <div>
              <p className="text-xs text-gray-500 font-medium mb-1">Active Days</p>
              <p className="text-2xl font-semibold text-gray-900">{currentStreak}</p>
            </div>
          </div>
          
          {/* Learning Hours Card */}
          <div className="flex items-center gap-3 bg-gray-50 border border-gray-200 rounded-lg px-5 py-4 min-w-[160px]">
            <ChartBarIcon className="w-7 h-7 text-gray-600" />
            <div>
              <p className="text-xs text-gray-500 font-medium mb-1">Total Progress</p>
              <p className="text-2xl font-semibold text-gray-900">{totalPoints}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeHeader;